import React from "react";
import {
    ControlMessages,
    ControlMessageGroup
} from "@tinqin/tinqin-ui-components/src/control-messages";
import Paragraph from "@tinqin/tinqin-ui-components/src/paragraph";
import utils from "../../app/UtilityService";
import containerUtils, {
    getEmptyContent,
    dispatchSirenActions,
    setDataInStore,
    resolveBinding,
    resolveCollectionItems
} from "../../utils/containerUtils";
import ObjectUtils from "@tinqin/tinqin-utils/src/object";
import translationService from "../../app/TranslationService";

export function ReduxControlMessages(props) {
    const onClose = (state) => {
        //In some cases we may want to resolve ControlMessages component manually and pass that!
        //Use case - Dialog global WebUI component!
        if (props.onClose) {
            props.onClose();
        } else {
            //Propagate the news to the store.
            setDataInStore(props, { visible: false });
            dispatchSirenActions(props, "close");
        }
    };

    const onAccept = (state) => {
        //In some cases we may want to resolve ControlMessages component manually and pass that!
        //Use case - Dialog global WebUI component!
        if (props.onAccept) {
            props.onAccept();
        } else {
            onClose(state);
            dispatchSirenActions(props); //Fire siren action if any.
        }
    };
    const getDefaultLabels = () => {
        let defaultGroupLabels = props.defaultGroupLabels || {};
        return {
            collapsedHint: translationService.translate("collapsedHintGroupLabel"),
            mapGroupLabel: {
                error: defaultGroupLabels["error"]
                    ? defaultGroupLabels["error"]
                    : translationService.translate("errorGroupLabel"),
                success: defaultGroupLabels["success"]
                    ? defaultGroupLabels["success"]
                    : translationService.translate("successGroupLabel"),
                warning: defaultGroupLabels["warning"]
                    ? defaultGroupLabels["warning"]
                    : translationService.translate("warningGroupLabel"),
                info: defaultGroupLabels["info"]
                    ? defaultGroupLabels["info"]
                    : translationService.translate("infoGroupLabel"),
                neutral: defaultGroupLabels["neutral"]
                    ? defaultGroupLabels["neutral"]
                    : translationService.translate("neutralGroupLabel")
            }
        };
    };

    const mapConfigToData = () => {
        let result = [];
        let config = props.config;
        let children = config.children || [];
        let data = props.data || {};
        let entities = data.entities || [];

        if (children.length) {
            children.forEach((child) => {
                result.push({ config: child });
            });
            result.forEach((item) => {
                let data;
                let bindTo = item.config.bindTo; //Note: If you config you are supposed to have bindTo.
                let binder = bindTo.substr(bindTo.lastIndexOf(".") + 1, bindTo.length);
                entities.forEach((entity) => {
                    let entityClass = entity.class || [];
                    let classifier = entityClass[0];
                    if (binder === classifier) {
                        data = entity;
                    }
                });

                if (data) {
                    item.data = data;
                }
            });
        } else {
            entities.forEach((entity) => {
                result.push({ data: entity });
            });
        }

        return result;
    };

    const buildMessages = (groupIndex, groupData, bindToTail) => {
        let messagesData = groupData.entities;
        let config = props.config.paragraph;

        if (config) {
            config.type = "paragraph"; //Note: we always render paragraph we don't need it in config.
            config.bindTo = "{parent}.{dynamicItem}"; //same bindTo for all inner messages
            let realBindTo = resolveBinding(props) + bindToTail;
            return resolveCollectionItems(props, {
                config: props.config,
                items: messagesData,
                computedBindTo: realBindTo,
                itemConfig: config
            });
        } else {
            let result = [];
            messagesData.forEach((data, index) => {
                let dataProps = data.properties || {};
                if (dataProps.value) {
                    result.push(
                        <Paragraph key={groupIndex + "-" + index} text={dataProps.value} />
                    );
                }
            });
            return result;
        }
    };

    const buildGroups = () => {
        let result = [];
        let labels = getDefaultLabels();
        let childrenData = mapConfigToData();

        childrenData.forEach((child, index) => {
            let childData = child.data || {};
            let childActions = childData.actions || [];

            if (!childData || ObjectUtils.isEmpty(childData)) {
                return;
            }

            let childProps = containerUtils.extractComponentProps(child, {
                componentProps: ControlMessageGroup.propTypes,
                propsDefaults: {
                    collapsedHint: labels.collapsedHint
                },
                skipDataTqId: true
            });
            let computedBindTo = child.computedBindTo || props.computedBindTo;
            childProps.onClose = () => {
                dispatchSirenActions(props, ["default", "close"], {
                    actions: childActions,
                    computedBindTo: computedBindTo,
                    configActions: child.config.actions
                });
            };

            //Defaulting 'name' based on type
            if (!childProps.name) {
                //Note: error is the default in tinqin-ui-components!
                childProps.name = labels.mapGroupLabel[childProps.groupType || "error"];
            }

            let bindToTail;
            if (child.config) {
                let bindTo = child.config.bindTo;
                bindToTail = bindTo.substr(bindTo.lastIndexOf("."), bindTo.length);
            } else {
                let classifier = child.data.class[0]; //Note: you must have classifier
                bindToTail = "." + classifier;
            }

            let messages = buildMessages(index, child.data, bindToTail);

            result.push(
                <ControlMessageGroup key={index} {...childProps}>
                    {messages}
                </ControlMessageGroup>
            );
        });

        return result;
    };
    if (!props.data) {
        return getEmptyContent();
    }
    let data = props.data;
    let dataProps = data.properties || {};
    let renderForFirstTime = dataProps.visible === undefined;
    if (dataProps.visible || renderForFirstTime) {
        let controlMessagesProps = containerUtils.extractComponentProps(props, {
            componentProps: ControlMessages.propTypes,
            skipDataTqId: true
        });

        controlMessagesProps.onClose = onClose;
        if (controlMessagesProps.hasOwnProperty("acceptLabel")) {
            controlMessagesProps.onAccept = onAccept;
        }

        return <ControlMessages {...controlMessagesProps}>{buildGroups()}</ControlMessages>;
    } else {
        return getEmptyContent();
    }
}

ReduxControlMessages.displayName = "ReduxControlMessages";

export default utils.connectComponent({
    actions: {
        dispatchSirenActions: "siren.dispatchSirenActions",
        triggerSet: "component.triggerSet"
    }
})(ReduxControlMessages);
